import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.PreparationMethod`]: 'Test Method',
      [`${prefix}.Preparation.OversizeMaterialRemovedBy`]: 'Oversize Material Removed By',
      [`${prefix}.Preparation.AsReceivedWaterContentDetermined`]: 'As Received Water Content Determined',
      [`${prefix}.Preparation.OversizeSieveApertureSize`]: 'Oversize Sieve Aperture Size',
      [`${prefix}.Preparation.EquivalentWaterContent`]: 'Equivalent Water Content of Test Portion',
      [`${prefix}.Preparation.PasteWaterContentEquilibrium`]: 'Paste Water Content Equilibrium',
      [`${prefix}.Preparation.NoOversizeMaterial`]: 'No Oversize Material',
      [`${prefix}.Preparation.StabiliserUsed`]: `Stabilized Material`,
      [`${prefix}.Preparation.StabiliserType`]: `Stabilizer Type`,
      [`${prefix}.Preparation.StabiliserAmount`]: `Stabilizer Amount`,
      [`${prefix}.Preparation.PreparationMethod`]: 'Preparation Method',

      [`${prefix}.Preparation.Balance`]: 'Balance',
      [`${prefix}.Preparation.Oven`]: 'Oven',
      [`${prefix}.Preparation.TareID`]: 'Tare ID',
      [`${prefix}.Preparation.TareMass`]: 'Tare Mass',
      [`${prefix}.Preparation.TareAndTotalSampleWetMass`]: 'Tare and Whole Specimen Wet Mass',
      [`${prefix}.Preparation.TotalSampleWetMass`]: 'Whole Specimen Wet Mass',
      [`${prefix}.Preparation.TotalSampleDryMass`]: 'Whole Specimen Dry Mass',
      [`${prefix}.Preparation.WashingSieve`]: 'Wash Sieve',
      [`${prefix}.Preparation.RetainedTareID`]: 'Oversize Material Tare ID',
      [`${prefix}.Preparation.TareMassRetained`]: 'Oversize Material Tare Mass',
      [`${prefix}.Preparation.TareAndDryMassRetained`]: 'Tare and Oversize Material Dry Mass',
      [`${prefix}.Preparation.DryMassRetained`]: 'Oversize Material Dry Mass',

      [`${prefix}.Preparation.MaterialDriedBy`]: 'Drying',
      [`${prefix}.Preparation.OvenForRetainedMaterial`]: 'Oven',

      [`${prefix}.Preparation.SoakingStartDateTime`]: 'Soaking Start',
      [`${prefix}.Preparation.SoakingEndDateTime`]: 'Soaking End',
      [`${prefix}.Preparation.SoakingPeriod`]: 'Soaking Time',
      [`${prefix}.LiquidLimit.NonPlastic`]: 'Material Suitability',
      [`${prefix}.LiquidLimit.Balance`]: 'Balance',
      [`${prefix}.LiquidLimit.Oven`]: 'Oven',
      [`${prefix}.LiquidLimit.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.LiquidLimit.DryingTemperature`]: 'Drying Temperature',
      [`${prefix}.LiquidLimit.Timer`]: 'Timer',
      [`${prefix}.LiquidLimit.Fallcone`]: 'Fallcone Apparatus',
      [`${prefix}.LiquidLimit.Cone`]: 'Cone',
      [`${prefix}.LiquidLimit.ConeType`]: 'Cone Type',
      [`${prefix}.LiquidLimit.IsConeSuitabilityChecked`]: 'Cone suitability checked',
      [`${prefix}.LiquidLimit.CorrelationFactorSource`]: 'Source of Correlation Factor',
      [`${prefix}.LiquidLimit.CorrelationFactor`]: 'Correlation Factor Value',
      [`${prefix}.LiquidLimit.Trials.ExcludedTrial`]: 'Exclude Trial',
      [`${prefix}.LiquidLimit.Trials.AveragePenetration`]: 'Average Penetration',
      [`${prefix}.LiquidLimit.WaterContentThroughPoints`]: 'Water Content Through Points',
      [`${prefix}.LiquidLimit.LiquidLimitPenetration`]: 'Penetration',
      [`${prefix}.LiquidLimit.WaterContent`]: 'Water Content',

      // Plastic Limit
      [`${prefix}.PlasticLimit.MaterialSuitability`]: 'Material Suitability',
      [`${prefix}.PlasticLimit.Balance`]: 'Balance',
      [`${prefix}.PlasticLimit.Oven`]: 'Oven',
      [`${prefix}.PlasticLimit.DryingTemperature`]: 'Drying Temperature',
      [`${prefix}.PlasticLimit.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.PlasticLimit.Trials.ExcludedTrial`]: 'Exclude Trial',

      // Results
      [`${prefix}.Results.PlasticLimit`]: 'Average Water Content',
      [`${prefix}.Results.PlasticLimitText`]: 'Plastic Limit',
      [`${prefix}.Results.LiquidLimitText`]: 'Liquid Limit',
      [`${prefix}.Results.PlasticityIndexText`]: 'Plasticity Index',
      [`${prefix}.Results.LiquidityIndexText`]: 'Liquidity Index',
      [`${prefix}.Results.ConsistencyIndex`]: 'Consistency Index',
      [`${prefix}.Results.ActivityIndex`]: 'Activity Index',
      [`${prefix}.Results.ActivityIndexCorrectionFactor`]: 'Activity Index Correction Factor',
      [`${prefix}.Results.ReportLiquidityIndex`]: 'Liquidity Index',
      [`${prefix}.Results.ReportConsistencyIndex`]: 'Consistency Index',
      [`${prefix}.Results.ReportActivityIndex`]: 'Activity Index',
      [`${prefix}.Results.ReportPlasticityChart`]: 'Plasticity Chart',
      [`${prefix}.Results.LiquidLimitPenetration`]: 'Penetration',
      [`${prefix}.Results.LiquidLimitWaterContent`]: 'Water Content',
      [`${prefix}.Results.LiquidLimitCorrelationFactor`]: 'Correlation Factor',
      [`${prefix}.Results.OptionalCharts`]: 'Optional Charts',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.OversizeSieveApertureSize`]: 'mm',
      [`${prefix}.Preparation.MaterialPercent`]: '%',
      [`${prefix}.Preparation.EquivalentWaterContent`]: '%',
      [`${prefix}.Results.LiquidLimitText`]: '%',
      [`${prefix}.LiquidLimit.WaterContent`]: '%',
      [`${prefix}.Results.PlasticLimit`]: '%',
      [`${prefix}.Results.PlasticLimitText`]: '%',
      [`${prefix}.Results.PlasticityIndexText`]: '%',
      [`${prefix}.Results.LiquidLimitWaterContent`]: '%',
      [`${prefix}.Preparation.StabiliserAmount`]: '%',
    })
  );

export default getLabelConfig;
